module.exports = __webpack_public_path__ + "static/img/banner-news.e9ae81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/banner-news.jpg
// module id = qlnE
// module chunks = 0